export default {
  hero: {
    title: "Basetao Spreadsheet — Der vollständige Leitfaden zu Produkten, Verkäufern und Ressourcen",
    subtitle:
      "Finden, vergleichen und verstehen Sie Basetao Spreadsheet Ressourcen an einem Ort. Entdecken Sie praktische Leitfäden, Verkäuferinformationen, Produktrecherche, Versandkosten, Lagerdetails, Gutscheine, Bewertungen, QC-Tipps und Sicherheitshinweise.",
    trust: "Unabhängige Ressource · Praktische Leitfäden · Regelmäßig aktualisiert",
    dropdownLabel: "Kategorie durchsuchen",
    dropdownPlaceholder: "Kategorie wählen…",
  },
  whatIs: {
    title: "Was ist Basetao Spreadsheet?",
    p1: "Ein Basetao Spreadsheet ist eine organisierte Produktdatenbank, die Käufern hilft, über den Einkaufsagenten Basetao verfügbare Artikel zu finden und zu vergleichen. Statt durch tausende einzelne Angebote zu scrollen, können Sie ein einziges strukturiertes Dokument durchsuchen, das Produkte nach Kategorie gruppiert und hilfreiche Details wie Verkäuferinformationen, Produktreferenzen und praktische Hinweise enthält.",
    p2: "Stellen Sie es sich wie eine Karte vor: Es verkauft selbst nichts, hilft Ihnen aber zu verstehen, welche Produkte existieren, wie sie gruppiert sind und wo Sie als Nächstes suchen sollten. Das Spreadsheet ist nach gängigen Einkaufskategorien organisiert — Schuhe, Hoodies, T-Shirts, Jacken, Taschen, Gürtel und mehr — damit Sie Ihre Suche schnell auf den gewünschten Produkttyp eingrenzen können.",
  },
  article: {
    title: "Leitfäden und Ressourcen",
    subtitle: "Lesen Sie klare, originelle Leitfäden, um das Beste aus dem Basetao Spreadsheet herauszuholen.",
    cardTitle: "Was ist Basetao Spreadsheet? Ein Leitfaden für Einsteiger",
    cardDesc:
      "Ein vollständiger, einsteigerfreundlicher Überblick: was das Spreadsheet ist, was es enthält, wie man es nutzt und was man vor der Bestellung prüfen sollte.",
    readMore: "Leitfaden lesen",
    viewAll: "Alle Leitfäden ansehen",
    related: "Verwandte Artikel",
    updated: "Regelmäßig aktualisiert",
  },
  faq: {
    title: "Häufig gestellte Fragen",
    q1: "Was ist Basetao Spreadsheet?",
    a1: "Es ist eine organisierte, kategoriebasierte Liste von Produkten und Referenzen, die Käufern hilft, über den Einkaufsagenten Basetao verfügbare Artikel zu recherchieren.",
    q2: "Wie nutze ich Basetao Spreadsheet?",
    a2: "Öffnen Sie das Spreadsheet, wählen Sie eine Kategorie, notieren Sie die gewünschten Produktreferenzen, vergleichen Sie Verkäuferdetails und prüfen Sie dann vor der Bestellung die aktuellen Preise und Verfügbarkeit auf der offiziellen Plattform.",
    q3: "Ist Basetao seriös?",
    a3: "Basetao ist ein bekannter Einkaufsagent, aber wie bei jedem Agenten sollten Sie Verkäufer, Produkte, Preise und Richtlinien immer selbst prüfen, bevor Sie eine Kaufentscheidung treffen.",
    q4: "Wie viel kostet der Basetao Versand?",
    a4: "Die Versandkosten hängen von Gewicht, Volumen, Zielort und gewählter Versandmethode ab. Die Tarife ändern sich mit der Zeit, prüfen Sie daher immer die aktuellen Bedingungen vor der Bestellung.",
    q5: "Hat Basetao Gutscheine oder Rabattcodes?",
    a5: "Angebote können von Zeit zu Zeit erscheinen, aber Verfügbarkeit und Teilnahmebedingungen können sich ändern. Prüfen Sie immer, ob ein Code noch gültig ist, bevor Sie sich darauf verlassen.",
  },
  ctaSection: {
    title: "Bereit, das vollständige Spreadsheet zu entdecken?",
    subtitle:
      "Durchsuchen Sie den vollständigen Produktkatalog, vergleichen Sie Kategorien und beginnen Sie mit der Produktrecherche auf der Hauptwebsite.",
    button: "Hauptwebsite besuchen",
  },
};